<template>
  <div
    v-if="isMobile"
    class="usp-carousel"
  >
    <div
      class="usp-carousel__progress"
    />
    <swiper
      :pagination="{
        type: 'progressbar',
        el: '.usp-carousel__progress',
      }"
      :autoplay="{
        delay: bannerSpeed,
        disableOnInteraction: false,
      }"
      loop
      slides-per-view="1"
      :modules="modules"
    >
      <swiper-slide
        v-for="(banner, index) of banners"
        :key="index"
        class="usp-carousel__banner"
      >
        <span
          v-if="banner.header"
          class="usp-carousel__header"
          v-text="banner.header"
        />

        <p
          v-if="banner.copy"
          class="usp-carousel__copy"
          v-text="banner.copy"
        />

        <btn
          v-if="banner.ctaCopy && banner.ctaLink"
          class="usp-carousel__cta"
          modifiers="text"
          :label="banner.ctaCopy"
          :url="banner.ctaLink"
          :show-icon="false"
        />
      </swiper-slide>
    </swiper>
  </div>
  <div
    v-else
    class="usp-carousel"
  >
    <div
      v-for="(banner, index) of banners"
      :key="index"
      class="usp-carousel__banner"
    >
      <span
        v-if="banner.header"
        class="usp-carousel__header"
        v-text="banner.header"
      />
      <p
        v-if="banner.copy"
        class="usp-carousel__copy"
        v-text="banner.copy"
      />
      <btn
        v-if="banner.ctaCopy && banner.ctaLink"
        class="usp-carousel__cta"
        modifiers="text"
        :label="banner.ctaCopy"
        :url="banner.ctaLink"
        :show-icon="false"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: USP carousel (usp-carousel)
 * -----------------------------------------------------------------------------
 * USP banners that display as a carousel on mobile.
 *
 * @param {Array} banners - section blocks for USP
 */
import { Autoplay, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { mapState } from 'vuex'
import Btn from '~global/btn/btn'

export default {
  name: 'UspCarousel',

  components: {
    Btn,
    Swiper,
    SwiperSlide,
  },

  props: {
    banners: {
      type: Array,
      default: () => [],
    },
    bannerSpeed: {
      type: Number,
      default: 4000,
    },
  },

  setup() {
    return {
      modules: [Autoplay, Pagination],
    }
  },

  data() {
    return {
      swiper: {},
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },
}
</script>

<style lang="scss">
@import './usp-carousel';
</style>
